import { Box, HStack, Text } from "@chakra-ui/react";
import { FaGift as GiftIcon } from "react-icons/fa";

export function FreeAccessAlertShell({ headline, body, footer, ...rest }) {
  return (
    <HStack
      align="flex-start"
      spacing={3}
      px={4}
      py={3}
      borderRadius="md"
      borderWidth="1px"
      borderColor="border"
      bg="bg-surface"
      {...rest}
    >
      <Box
        as={GiftIcon}
        boxSize="22px"
        color="warning"
        mt="2px"
        flexShrink={0}
        aria-hidden="true"
      />
      <Box flexGrow={1}>
        <Text fontSize="sm" fontWeight="semibold">
          {headline}
        </Text>
        <Text fontSize="sm" color="muted">
          {body}
        </Text>
        {footer ? (
          <Text mt={1} fontSize="xs" color="subtle">
            {footer}
          </Text>
        ) : null}
      </Box>
    </HStack>
  );
}
